import React from 'react';
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import {
  AuthorizationHandler,
  App,
  ConfirmDialog,
  HotNotification,
  Main,
  Notification,
  PrintContent,
  PaginationComponent,
} from 'components';

import About from 'routes/About';
import Calendar from 'routes/Calendar';
import Faqs from 'routes/Faqs';
import Features from 'routes/Features';
import Home from 'routes/Home';
import MarketPlace from 'routes/MarketPlace';
import MarketPlaceDetails from 'routes/MarketPlaceDetails';
import NoPermission from 'routes/NoPermission';
import OrderSheet from 'routes/OrderSheet';
import OrganizationLoginMembers from 'routes/OrganizationLoginMembers';
import Page404 from 'routes/Page404';
import Payments from 'routes/Payments';
import PublicProfile from 'routes/PublicProfile';
import PublicShop from 'routes/PublicShop';
import Pricing from 'routes/Pricing';
import PrivacyPolicy from 'routes/Privacy';
import Profile from 'routes/Profile';
import ProfileSaved from 'routes/ProfileSaved';
import Sources from 'routes/Sources';
import RetailSources from 'routes/RetailSources';
import Store from 'routes/Store';
import Team from 'routes/Team';
import TermsOfService from 'routes/Terms';
import Transactions from 'routes/Transactions';
import VendorSettings from 'routes/VendorSettings';
import RegenPractices from 'routes/RegenPractices';
import ContactUs from 'routes/ContactUs';
import RetailShop from 'routes/RetailShop';
import Products from 'routes/Products';

const AuthorizedRoutes = props => (
  <AuthorizationHandler {...props}>
    <App {...props}>
      <Switch>
        <Route path="/track-orders" component={Calendar} />
        <Route path="/catalog" component={Store} />
        <Route path="/order" component={OrderSheet} />
        <Route path="/payments" component={Payments} />
        <Route path="/settings" component={Profile} />
        <Route path="/settings-saved" component={ProfileSaved} />
        <Route path="/customers" component={Sources} />
        <Route path="/retail-customers" component={RetailSources} />
        <Route path="/vendors" component={Sources} />
        <Route path="/storefront" component={Store} />
        <Route path="/retail-shop" component={RetailShop} />
        <Route path="/members" component={OrganizationLoginMembers} />
        <Route path="/transactions" component={Transactions} />
        <Route path="/availability-list" component={VendorSettings} />
        <Route path="/regen-practices" component={RegenPractices} />
        <Route exact path="/no-permission" component={NoPermission} />
        <Route path="*" component={Page404} />
      </Switch>
    </App>
  </AuthorizationHandler>
);

const Router = () => (
  <Main>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/shop@*" component={PublicProfile} />
        <Route path="/+*" component={PublicProfile} />
        <Route path="/about" component={About} />
        <Route path="/shop" component={PublicShop} />
        <Route
          path="/signup/:type"
          render={({ match }) => (
            <Redirect
              to={{
                pathname: '/',
                search: `?preset_role=${match.params.type}`,
              }}
            />
          )}
          exact
        />
        <Route exact path="/faq" component={Faqs} />
        <Route exact path="/features" component={Features} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/marketplace" component={MarketPlace} />
        <Route exact path="/products/:id" component={MarketPlaceDetails} />
        <Route exact path="/team" component={Team} />
        <Route exact path="/terms" component={TermsOfService} />
        <Route exact path="/privacy" component={PrivacyPolicy} />
        <Route exact path="/contact" component={ContactUs} />
        <Route exact path="/products" component={Products} />
        <Route path="*" component={AuthorizedRoutes} />
      </Switch>
    </BrowserRouter>
    <Notification />
    <ConfirmDialog />
    <PrintContent />
    <PaginationComponent />
    <HotNotification />
  </Main>
);

export default Router;
